export enum UserRoleScopes {
  companyEdit = 'companyEdit',
  products = 'products',
  clients = 'clients',
  stats = 'stats',
  finances = 'finances',
  integrations = 'integrations',
  access = 'access',
}

export enum UserRoles {
  admin = 'admin',
  owner = 'owner',
  worker = 'worker',
}

export interface UserRole {
  accessId: string;
  calendarCount: number;
  hasLoggedIn: boolean;
  note: string;
  phoneNumber: string;
  countryIsoCode: string;
  role: UserRoles;
  scopes: UserRoleScopes[];
}

export interface UserRoleDetails extends Omit<UserRole, 'calendarCount'> {
  calendars: {
    id: string;
    title: string;
  }[];
}

export interface CreateUserRoleParams {
  calendarIds?: string[];
  isAdmin: boolean;
  note: string;
  phoneNumber: string;
  countryIsoCode: string;
  scopes?: UserRoleScopes[];
}
